<script setup lang="ts">
const props = defineProps<{
  blured?: boolean
  line?: boolean
  blue?: boolean
  grey?: boolean
  border?: boolean
  txt: stringI18n | undefined
  sup?: string | number | None
  noicon?: boolean
  open: boolean
  block?: boolean
}>()
const init3 = useInited('init3')
const css = useCssModule()
const tablet = 'bg _br99 _gap1 _pl08 _pr04 _hidden'

const cssClass = computed(() => {
  const { block, blue, blured, border, grey, noicon, open } = props
  const res = [css.btn, open && 'on', block && css.block, blured && '_c45', noicon && css.noicon]
  if (blue) res.push('blue', tablet)
  else if (grey) res.push('grey', tablet)
  else if (border) res.push('border', tablet)
  else res.push('line')
  return res
})
</script>

<template>
  <button type="button" class="_relative _wcont _hm28 _c1 _fw-xl _ls-xs _row _inline _ctrY _lh1 _gap06" :class="cssClass">
    <span v-if="line" :class="$style.line" />
    <span class="_ctr _gap04 _fs09"
      ><slot
        >{{ txt }}<sup v-if="helpers.isDef(sup)" :class="$style.sup">{{ helpers.zeroPad(sup) }}</sup></slot
      ></span
    >

    <span v-if="!noicon" class="_svg20">
      <LazyIconChevron v-if="init3" :open />
    </span>
  </button>
</template>

<style module>
.btn {
  font-size: inherit;
  --svg-color: var(--black-45);
}

.sup {
  composes: global(_relative);
  composes: global(_fw-xxxl);
  composes: global(_pr04);
  composes: global(_pl04);

  composes: global(_br99);

  composes: global(_c0);
  composes: global(_bg1);

  top: -4px;
  left: 0;
  line-height: 11px;
}

.btn:global(.line)::after {
  content: '';
  display: block;
  width: calc(100% - 4px);
  height: var(--h, 0px);
  background: var(--b, var(--black-5));
  position: absolute;
  left: 0;
  top: calc(100% - 1px);
  border-radius: 0 0 9px 9px;
  transition:
    border-color 100ms var(--tran2),
    height 100ms var(--tran2);
  margin: 0 auto;
  right: 0;

  transform-origin: calc(50% - 23px) 0;
  transition:
    color 0.175s ease,
    background-color 0.15s ease,
    box-shadow 0.15s cubic-bezier(0.175, 0.885, 0.32, 1.275),
    transform 0.175s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.noicon:global(.line):after {
  transform-origin: 50% 0;
}
.btn:global(.blue) {
  background: var(--blue3);
  --bg1: var(--blue2);
  color: var(--bg);
  --svg-color: var(--bg);
  --svg: 14px;
}
.btn:global(.grey) {
  background: var(--black-5);
  --bg1: var(--blue3);
  --svg: 14px;
}
.btn:global(.border) {
  background: var(--bg);
  --color: var(--black);
  --bg1: var(--black);
  border: 1px solid var(--black);
  --svg: 14px;
}
.btn:global(.bg):global(.on),
:global(.d) .btn:global(.bg):hover {
  background: var(--bg1);
  color: var(--bg);
  --svg-color: var(--bg);
}

.btn:focus-visible {
  --h: 2px;
  color: var(--blue3);
  --b: currentColor;
  --svg-color: currentColor;
}

.btn:hover {
  color: var(--black);
  --svg-color: var(--black);
  --h: 2px;
  --b: var(--black-5);
}
.btn:global(.on) {
  --h: 2px;
  color: var(--black);
  --b: var(--black);
  --svg-color: var(--black);
}

.btn:global(.line):global(.on)::after {
  transform: scaleX(0.65);
}

.block {
  composes: global(_row);
  --b: transparent;
}

.line {
  composes: global(_relative);
  composes: global(_mr04);
  composes: global(_noflex);
  composes: global(_inline);

  box-sizing: border-box;
  font-size: 100%;
  width: 24px;
  height: 1px;
  background: var(--black-4);
  align-self: center;
}
</style>
